/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
	source: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
	altText: PropTypes.string.isRequired,
	dimensions: PropTypes.object,
	className: PropTypes.string,
	onClick: PropTypes.func,
	id: PropTypes.string,
};

const Image = ({ source, altText, dimensions, className, onClick, id }) => (
	<img
		onClick={onClick}
		className={className || ''}
		style={dimensions ? { ...dimensions } : null}
		src={source || ''}
		alt={altText || ''}
		id={id}
	/>
);

Image.propTypes = propTypes;

export default Image;
